import AnniPage from "@/pages/cms/anni/AnniPage";
import BrandPage from "@/pages/cms/brand/BrandPage";
import CategoriePage from "@/pages/cms/categorie/CategoriePage";
import TagPage from "@/pages/cms/tag/TagPage";
import TipologiePage from "@/pages/cms/tipologie/TipologiePage";
import TemporaryUrlsPage from "@/pages/cms/temporary-urls/TemporaryUrlsPage";

export default [
    {
        path: 'cms/anni',
        name: 'CmsAnniPage',
        component: AnniPage,
        meta: {
            title: 'Findus | Digital Archive - Gestione Anni'
        }
    },
    {
        path: 'cms/brand',
        name: 'CmsBrandPage',
        component: BrandPage,
        meta: {
            title: 'Findus | Digital Archive - Gestione Brand'
        }
    },
    {
        path: 'cms/categorie',
        name: 'CmsCategoriePage',
        component: CategoriePage,
        meta: {
            title: 'Findus | Digital Archive - Gestione Categorie'
        }
    },
    {
        path: 'cms/tag',
        name: 'CmsTagPage',
        component: TagPage,
        meta: {
            title: 'Findus | Digital Archive - Gestione Tag'
        }
    },
    {
        path: 'cms/tipologie',
        name: 'CmsTipologiePage',
        component: TipologiePage,
        meta: {
            title: 'Findus | Digital Archive - Gestione Tipologie'
        }
    },
    {
        path: 'cms/link-di-condivisione',
        name: 'CmsTemporaryUrlsPage',
        component: TemporaryUrlsPage,
        meta: {
            title: 'Findus | Digital Archive - Gestione Link di Condivisione'
        }
    },
];



// WEBPACK FOOTER //
// ./src/router/modules/cms.js